import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in");
        });
      },
      { threshold: 0.15 }
    );

    const observeAll = () => {
      document.querySelectorAll(".reveal:not(.in)").forEach((el) => observer.observe(el));
    };
    observeAll();

    // Re-observe new elements added dynamically (async data loads)
    const mutation = new MutationObserver(() => observeAll());
    mutation.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutation.disconnect();
    };
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#0B0B0B]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
